import React from 'react'
import { Typography } from '@mui/material'

/** Greys a zero, so a column of counts reads as the rows that have something. */
export const DataTableCount = ({ value }: { value: number }) => (
    <Typography variant="18x600" color={value ? 'figma.primary' : 'figma.grayscale.tier3'}>
        {value.toLocaleString('en-US')}
    </Typography>
)

export default DataTableCount
